import React, { useEffect, useRef, useState } from "react";
import { Zap, MapPin, Star, ShieldCheck } from "lucide-react";

const COUNTERS = [
  { icon: Zap, target: 42, suffix: "s", label: "Average unlock-to-ride time" },
  { icon: MapPin, target: 148, suffix: "+", label: "Verified drivers ready at launch" },
  { icon: Star, target: 4.9, suffix: "/5", label: "Early rider satisfaction", decimal: true },
  { icon: ShieldCheck, target: 100, suffix: "%", label: "Cashless & card ready" },
];

function Counter({ target, suffix, decimal }) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const dur = 1400;
          const start = performance.now();
          const tick = (now) => {
            const p = Math.min((now - start) / dur, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            setVal(decimal ? +(target * eased).toFixed(1) : Math.round(target * eased));
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      });
    }, { threshold: 0.5 });
    io.observe(el);
    return () => io.disconnect();
  }, [target, decimal]);

  return (
    <span ref={ref} className="font-display font-extrabold text-white text-4xl sm:text-5xl">
      {decimal ? val.toFixed(1) : val}
      <span className="text-[#2fd645]">{suffix}</span>
    </span>
  );
}

export default function StatsBar() {
  return (
    <section className="relative py-16 bg-[#0a0e0c] border-b border-white/5">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {COUNTERS.map((c) => {
            const Icon = c.icon;
            return (
              <div key={c.label} className="text-center">
                <div className="mx-auto mb-3 h-11 w-11 rounded-xl bg-[#2fd645]/12 border border-[#2fd645]/25 flex items-center justify-center">
                  <Icon className="h-5 w-5 text-[#2fd645]" />
                </div>
                <Counter target={c.target} suffix={c.suffix} decimal={c.decimal} />
                <p className="mt-2 text-sm text-white/55">{c.label}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
